import * as React from "react";

function SvgSnapboard(props, ref) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 260 260"
      xmlns="http://www.w3.org/2000/svg"
      {...{ ...props, ref }}
    >
      <g fill="none" fillRule="evenodd">
        <path
          d="M84 130.385v92.23c0 2.222-.892 4.36-2.486 5.933A8.568 8.568 0 0175.5 231h-34c-4.696 0-8.5-3.752-8.5-8.385v-92.23c0-4.633 3.804-8.385 8.5-8.385h34c2.253 0 4.42.88 6.014 2.452A8.335 8.335 0 0184 130.385z"
          fill="#E36F6F"
        />
        <path
          d="M219.5 87h-34c-4.696 0-8.5 3.79-8.5 8.47v127.06c0 2.244.892 4.404 2.486 5.992A8.523 8.523 0 00185.5 231h34c2.253 0 4.42-.89 6.014-2.478A8.464 8.464 0 00228 222.53V95.47a8.464 8.464 0 00-2.486-5.992A8.524 8.524 0 00219.5 87z"
          fill="#F3AE4B"
        />
        <path
          d="M147.5 29h-34c-4.696 0-8.5 3.766-8.5 8.417v185.166c0 2.23.892 4.377 2.486 5.955A8.551 8.551 0 00113.5 231h34c2.253 0 4.42-.884 6.014-2.462a8.383 8.383 0 002.486-5.955V37.417c0-2.23-.892-4.377-2.486-5.955A8.552 8.552 0 00147.5 29z"
          fill="#00A8B5"
        />
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgSnapboard);
